import React from "react"
import { css } from "@emotion/react"
import { formatCurrency } from "@ncs/ts-utils"
import { Box, BoxProps, SkeletonRows } from "@ncs/web-legos"

export interface OrderSummaryRowProps extends BoxProps {
	label: string | React.ReactNode
	amount: string | number | null
	isLoading?: boolean
	color?: string
}

export const OrderSummaryRow: React.FC<OrderSummaryRowProps> = ({
	label,
	amount,
	isLoading,
	color,
	...rest
}) => {
	return (
		<Box display="flex" justifyContent="space-between" mb={0.5} {...rest}>
			<span>{label}</span>

			<span css={amountStyle(color)}>
				{isLoading ?
					<SkeletonRows width={4} rows={1} />
				: typeof amount === "number" ?
					formatCurrency(amount)
				:	amount}
			</span>
		</Box>
	)
}

const amountStyle = (color?: string) => css`
	font-weight: bold;
	color: ${color ?? "#002648"};
`
